module.exports = __webpack_public_path__ + "img/SNT.17543df6.svg";